import type { UserPreferencesNotificationsProps } from "./user-preferences-notifications.type";
import type { PropsWithChildren } from "react";

import { ConfigProvider } from "antd";

import { UserPreferencesNotificationsContext } from "./user-preferences-notifications.context";
import { useUserPreferencesNotifications } from "./user-preferences-notifications.hook";
import { notificationsTableTheme } from "./user-preferences-notifications.theme";

export const UserPreferencesNotificationsProvider = ({
  notifications,
  savedSettings,
  children,
}: PropsWithChildren<UserPreferencesNotificationsProps>) => {
  const values = useUserPreferencesNotifications({
    notifications,
    savedSettings,
  });

  return (
    <UserPreferencesNotificationsContext.Provider value={values}>
      <ConfigProvider theme={notificationsTableTheme}>
        {children}
      </ConfigProvider>
    </UserPreferencesNotificationsContext.Provider>
  );
};
